export default fieldsErrors => {
  return Object.keys(fieldsErrors).some(elem => fieldsErrors[elem])
}
